import axios from 'axios';

export function getAdvertiserTos() {
    return axios.get(`${process.env.REACT_APP_API_URL}/legal/advertiser-tos`);
}
